import React from 'react';
import { ExportButton, useListContext, useRedirect } from 'react-admin';
import DiscountIcon from '@mui/icons-material/Discount';
import { ListOrigin } from '../../resources/discounts/v2/types';

const CreateDiscountButton: React.FC<any> = (props) => {

  const redirect = useRedirect();
  const { resource } = useListContext();

  const createDiscount = (records: any[]) => {
    // `origin`: o cadastro de desconto não chama de "Painel 360" uma lista que veio de um relatório
    redirect('/discounts/create', undefined, undefined, undefined, { customerIds: records.map(record => record.id), type: 'special', origin: ListOrigin.report });
  }

  return (
    <ExportButton
      resource={resource}
      icon={<DiscountIcon style={{ fontSize: 18 }} />}
      label="Criar Desconto"
      exporter={createDiscount}
      variant='outlined'
      sx={{ height: 32, marginBottom: '3px' }}
      //@ts-ignore
      maxResults={null} //unlimited
    />
  );
}

export default CreateDiscountButton;